import { yupResolver } from "@hookform/resolvers/yup";
import { TextField } from "@mui/material";
import { useContext, useState } from "react";
import { SubmitHandler } from "react-hook-form";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../providers/UserContext";
import { ButtonStyled } from "../../../style/button";
import { registerSchema } from "./registerSchema";
import { RegisterFormStyled } from "./style";
import { iRegisterFormValues } from "./types";

export const RegisterForm = () => {
  const navigate = useNavigate();
  const { userRegister } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<iRegisterFormValues>({
    mode: "onBlur",
    resolver: yupResolver(registerSchema),
  });

  const submit: SubmitHandler<iRegisterFormValues> = async (data) => {
    userRegister(data, setLoading);
  };

  return (
    <RegisterFormStyled noValidate onSubmit={handleSubmit(submit)}>
      <TextField
        color="success"
        required
        id="name"
        type="text"
        label="Nome"
        placeholder="Digite seu nome aqui"
        fullWidth
        disabled={loading}
        {...register("name")}
        error={!!errors.name}
        helperText={errors.name?.message}
      />
      <TextField
        color="success"
        required
        id="email"
        type="email"
        label="Email"
        placeholder="Digite seu e-mail aqui"
        fullWidth
        disabled={loading}
        {...register("email")}
        error={!!errors.email}
        helperText={errors.email?.message}
      />
      <TextField
        color="success"
        required
        id="password"
        type="password"
        label="Senha"
        placeholder="Digite sua senha aqui"
        fullWidth
        disabled={loading}
        {...register("password")}
        error={!!errors.password}
        helperText={errors.password?.message}
      />
      <TextField
        color="success"
        required
        id="confirmPassword"
        type="password"
        label="Confirmar senha"
        placeholder="Digite novamente sua senha aqui"
        fullWidth
        disabled={loading}
        {...register("confirmPassword")}
        error={!!errors.confirmPassword}
        helperText={errors.confirmPassword?.message}
      />
      <ButtonStyled type="submit" buttonStyle="secondaryMedium" weigth={600}>
        Cadastrar
      </ButtonStyled>
    </RegisterFormStyled>
  );
};
